import { get } from "../../api";
import { SELECT_CURRENT_DOCUMENT, USER_LOGIN, USER_LOGOUT, SET_DOCUMENT_LIST, SET_SAS_TOKEN, SET_IP_ADDRESS, SET_USER_PAGE } from "../actionTypes";
import * as publicIp from 'public-ip';

export const setCurrentDocument = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SELECT_CURRENT_DOCUMENT,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const setLoginDataDetail = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: USER_LOGIN,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const setLogout = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: USER_LOGOUT,
        payload: null,
      });
    } catch (error) {
      console.error(error);
    }
  };
};


export const setUserCurrentPage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_USER_PAGE,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };
};


export const setDocumentList = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_DOCUMENT_LIST,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };
};



export const getSasToken = () => {
  return async (dispatch) => {
    try {
      const url ="/api/document/generate-sas-token";
      const res = await get(url);
      dispatch({
        type: SET_SAS_TOKEN,
        payload: res?.sasToken,
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getIPAddress = () => {
  return async (dispatch) => {
    try {
      const ipAddress = await publicIp.publicIpv4();
      dispatch({
        type: SET_IP_ADDRESS,
        payload: ipAddress,
      });
    } catch (error) {
      console.error(error);
    }
  };
};